module.exports = __webpack_public_path__ + "static/media/100-a-day-small.ce009a90.png";